import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { fetchApi } from '../services/api';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,

  Button,
  Typography,
  FormControl,
  Select,
  MenuItem as MuiMenuItem,
  
  AppBar,
  IconButton,
  useMediaQuery,
  
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTheme as useCustomTheme } from '../theme/ThemeProvider';
import { COLOR_SETS } from '../theme/colorSets';
import { useUser } from '../contexts/UserContext';
import {
  Dashboard as DashboardIcon,
  ListAlt as ListAltIcon,
  Add as AddIcon,
  Share as ShareIcon,
  Business as BusinessIcon,
  Star as StarIcon,
  Bookmark as BookmarkIcon,
  WarningAmber as WarningIcon,
  DeleteOutline as DeleteIcon,
  People as PeopleIcon,
  Menu as MenuIcon,
  SupportAgent as SupportAgentIcon,
  UploadFile as UploadFileIcon,
  Favorite as FavoriteIcon,
  HelpOutline as HelpOutlineIcon,
  MapOutlined as MapOutlinedIcon,
  ExitToApp as LogoutIcon,
  ViewList as ViewListIcon,
  LiveHelp,
  QuestionMark as QuestionMarkIcon,
  Info as InfoIcon,
  PeopleOutline as PeopleOutlineIcon,
} from '@mui/icons-material';
import { logout } from '../services/auth';
interface ApiTableResponse {
  table: UserInfo[];
}
interface UserInfo {
  업체번호: string;
  유저번호: string;
  업체명: string;
  유저명: string;
  대표이메일: string;
  프로필사진: string;
}

interface SideMenuProps {
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
  window?: () => Window;
}

interface MenuItem {
  text: string;
  icon: React.ReactNode;
  path?: string;
  onClick?: () => void;
  description?: string;
}



const SideMenu: React.FC<SideMenuProps> = ({ mobileOpen, handleDrawerToggle, window: propWindow }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const drawerWidth = 240;
  const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);
  const theme = useTheme();
  const { currentColorSet, setColorSet } = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { userInfo, fetchUserInfo, clearUserInfo } = useUser();

  // useEffect(() => {
  //   const fetchUserInfo = async () => {
  //     const token = localStorage.getItem('token');
  //     const CompanyNo = localStorage.getItem('CompanyNo');
  //     const UserNo = localStorage.getItem('UserNo');
  //     const procedureName = "DBO.CW_S_유저정보";
  //     if (!token) return;

  //     try {
  //       const postData = [
  //         { "컬럼명": "@업체번호", "값": CompanyNo },
  //         { "컬럼명": "@유저번호", "값": UserNo }
  //       ];

  //       const response = await fetchApi<ApiTableResponse>(procedureName, postData);

  //       if (response.data && response.data.table) {
  //         setUserInfo(response.data.table[0]);
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch user info:', error);
  //     }
  //   };

  //   fetchUserInfo();
  // }, []);

  const handleLogout = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    localStorage.clear();
    clearUserInfo();  // 유저 정보 초기화
    navigate('/login');
  };

  const cancelLogout = () => {
    setLogoutDialogOpen(false);
  };

  const handleKakaoChat = useCallback(() => {
    if (typeof window !== 'undefined' && window?.screen) {
      const width = 500;
      const height = 700;
      // 듀얼 모니터 등을 고려하여 현재 작업 중인 화면의 중앙에 위치하도록 수정
      const screenLeft = window.screenLeft || window.screenX;
      const screenTop = window.screenTop || window.screenY;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const left = screenLeft + (windowWidth - width) / 2;
      const top = screenTop + (windowHeight - height) / 2;

      window.open(
        'http://pf.kakao.com/_yHLmG/chat',
        '_blank',
        `width=${width},height=${height},top=${top},left=${left},location=no,toolbar=no,resizable=no`
      );
    }
  }, []);

  const [iconColors, setIconColors] = useState<string[]>([]);

  useEffect(() => {
    const colors = [
      {
        text: '일정 플랫폼',
        icon: <ShareIcon />,
        path: '/itinerary-share'
      },
      {
        text: '일정등록',
        icon: <AddIcon />,
        path: '/uploadHwp'
      },
      {
        text: '내 일정표',
        icon: <ListAltIcon />,
        path: '/itinerary-list'
      },
      {
        text: '즐겨찾기',
        icon: <BookmarkIcon />,
        path: '/favorite'
      },
      {
        text: '휴지통',
        icon: <DeleteIcon />,
        path: '/itinerary-recycle'
      },
      {
        text: '상담관리',
        icon: <SupportAgentIcon />,
        path: '/counseling'
      },
      {
        text: '고객관리',
        icon: <PeopleIcon />,
        path: '/customers'
      },
      {
        text: '회사정보',
        icon: <BusinessIcon />,
        path: '/company-info'
      },
      {
        text: '직원관리',
        icon: <PeopleIcon />,
        path: '/employee-management'
      },
      {
        text: '시스템 문의',
        icon: <LiveHelp />,
        onClick: handleKakaoChat
      },
      {
        text: '사이트맵',
        icon: <MapOutlinedIcon />,
        path: '/sitemap'
      }
    ].map(() => {
      const randomIndex = Math.floor(Math.random() * COLOR_SETS.length);
      const colorSet = COLOR_SETS[randomIndex];
      const primaryColor = (colorSet?.palette?.primary as any)?.main || '#1976d2';
      return primaryColor;
    });
    setIconColors(colors);
  }, []); // 빈 의존성 배열로 마운트 시에만 실행

  const menuItems: MenuItem[] = useMemo(() => [
    {
      text: '일정 플랫폼',
      icon: <ShareIcon />,
      path: '/itinerary-share',
      description: '전세계 여행일정을 한눈에 확인하고 활용할 수 있는 B2B 플랫폼입니다. 랜드사, 여행사가 등록한 여행일정, 가격, 출발일, 관광지 정보를 검색하여 확인하고 내 일정표로 다운로드할 수 있습니다. 일정표를 등록한 회사의 연락처, 이메일, 주소 및 보증보험 가입 현황도 투명하게 제공됩니다.'
    },
    {
      text: '일정등록',
      icon: <AddIcon />,
      path: '/uploadHwp',
      description: '기존 엑셀 일정표를 클릭 한 번으로 스마트한 웹 일정표로 변환하세요. 도시, 장소 자동 매칭과 관광지 정보가 자동으로 등록되며, 거래처와 고객이 필요한 시점에 웹, HWP, XLS, PDF 형식으로 즉시 공유가 가능합니다.'
    },
    {
      text: '내 일정표',
      icon: <ListAltIcon />,
      path: '/itinerary-list',
      description: '기존 엑셀 일정표를 클릭 한 번으로 스마트한 웹 일정표로 변환하세요. 도시, 장소 자동 매칭과 관광지 정보가 자동으로 등록되며, 거래처와 고객이 필요한 시점에 웹, HWP, XLS, PDF 형식으로 즉시 공유가 가능합니다.'
    },
    {
      text: '즐겨찾기',
      icon: <BookmarkIcon />,
      path: '/favorite',
      description: '자주 사용하는 일정표와 중요한 정보를 즐겨찾기에 등록하여 효율적으로 관리하세요. 자주 방문하는 도시의 관광지 정보, 주요 거래처의 일정표, 인기 있는 패키지 상품을 즐겨찾기에 추가하여 클릭 한 번으로 빠르게 접근할 수 있습니다.'
    },
    {
      text: '휴지통',
      icon: <DeleteIcon />,
      path: '/itinerary-recycle',
      description: '실수로 삭제한 일정표나 정보를 안전하게 복구할 수 있는 공간입니다. 삭제된 항목은 30일간 휴지통에 보관되며, 이 기간 동안 언제든지 복구가 가능합니다.'
    },
    {
      text: '상담관리',
      icon: <SupportAgentIcon />,
      path: '/counseling',
      description: '고객 상담 내역을 등록/관리하고, 상담 예약 및 진행 상황을 쉽게 확인할수 있습니다. 또한, 판매가, 세부원가, 예상수익 및 미수, 미지급금 관리를 효율적으로 관리할 수 있습니다.'
    },
    {
      text: '고객관리',
      icon: <PeopleOutlineIcon />,
      path: '/customers'
    },
    {
      text: '회사정보',
      icon: <BusinessIcon />,
      path: '/company-info',
      description: '회사의 핵심 정보를 한눈에 확인하고 관리할 수 있는 공간입니다. 회사 로고, 상호, 대표자명, 사업자등록번호부터 연락처, 이메일, 주소까지 모든 정보를 체계적으로 관리할 수 있습니다.'
    },
    {
      text: '직원관리',
      icon: <PeopleIcon />,
      path: '/employee-management',
      description: '직원 정보와 권한을 효율적으로 관리할 수 있습니다. 직원들의 계정을 생성하고 각각의 권한을 설정할 수 있으며, 업무 현황과 성과를 체계적으로 관리할 수 있습니다.'
    },
    {
      text: '시스템 문의',
      icon: <LiveHelp />,
      onClick: handleKakaoChat,
      description: '시스템 사용 중 발생하는 모든 문의사항을 실시간으로 해결해드립니다. 카카오톡 채널을 통해 빠르고 정확한 답변을 받을 수 있으며, 시스템 개선 요청이나 새로운 기능 제안도 가능합니다.'
    },
    {
      text: '사이트맵',
      icon: <MapOutlinedIcon />,
      path: '/sitemap',
      description: '시스템의 전체 구조와 각 메뉴의 상세 설명을 확인할 수 있습니다.'
    }
  ], [handleKakaoChat, handleLogout]);

  const drawer = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', height: '70px' }}>
          <Toolbar sx={{ justifyContent: 'space-between', pl: 2 , width: '150px'}}>
            <img src="/landbox.png" alt="Logo" style={{ height: '40px', width: 'auto' }} />
            <Button size="small" onClick={handleLogout}><LogoutIcon /></Button>
          </Toolbar>
      </div>
      {!isMobile && <Divider sx={{ mr: 2, ml: 2, mt: 0, mb: 1 }} />}

      {userInfo && (
        <div>
          <Box sx={{ pl: 2, pt: { xs: 0, sm: 1 }, pr: 2, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
            <div>
              <Typography sx={{ pl: 2 }} variant="subtitle1" fontWeight="bold">
                {userInfo?.업체명} [{userInfo?.유저명}]
              </Typography>
              <Typography sx={{ pl: 2 }} variant="body2">

              </Typography>
              <Typography sx={{ pl: 2, pb: 2 }} variant="body2" color="text.secondary" >
                {userInfo?.대표이메일}
              </Typography>
            </div>
            {/* <Button size="small" onClick={handleLogout}><LogoutIcon /></Button> */}
          </Box>
          <Divider sx={{ mr: 2, ml: 2, mt: 0, mb: 1 }} />
        </div>

      )}
      <List>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.text}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={item.onClick ? item.onClick : () => {
                  if (item.path) {
                    navigate(item.path);
                    if (isMobile) { handleDrawerToggle();}
                  }
                }}
                selected={item.path === location.pathname}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: 3, justifyContent: 'center', color: iconColors[index] }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: '14px',
                    fontWeight: item.path === location.pathname ? 'bold' : 'normal',
                    color: item.path === location.pathname ? theme.palette.primary.main : theme.palette.text.primary
                  }}
                />
                {/* <Tooltip title={
                  <Typography sx={{ fontSize: '13px' }}>
                    {item.description}
                  </Typography>
                } placement="right" arrow
                >

                  <Box sx={{ color: '#888', height: 20, width: 20, mr: 1 }}>
                    <InfoIcon sx={{ fontSize: 24, ml: 0, opacity: 0.7 }} />
                  </Box>
                </Tooltip> */}
              </ListItemButton>
            </ListItem>
            {(item.text === '일정 목록' || item.text === '휴지통' || item.text === '직원관리') && <Divider sx={{ mr: 2, ml: 2, mt: 1, mb: 1 }} />}
          </React.Fragment>
        ))}
      </List>
      <Box sx={{ mt: 'auto', mb: 2, px: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          테마 선택
        </Typography>
        <FormControl fullWidth>
          <Select
            value={currentColorSet}
            onChange={(e) => setColorSet(e.target.value)}
            MenuProps={{
              disablePortal: true,
              keepMounted: true
            }}
          >
            {COLOR_SETS.map((colorSet) => (
              <MuiMenuItem key={colorSet.id} value={colorSet.id}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      backgroundColor: colorSet.thumbnail,
                      marginRight: 1,
                    }}
                  />
                  <Typography variant="body2">{colorSet.name}</Typography>
                </Box>
              </MuiMenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );

  const container = propWindow !== undefined ? () => propWindow().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Mobile AppBar */}
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            width: '100%',
            display: { sm: 'none' },
            bgcolor: 'background.paper',
            boxShadow: 'none',
            borderBottom: '1px solid',
            borderColor: 'divider',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar sx={{
            minHeight: { xs: 48 },
            padding: { xs: '0 !important' }
          }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ ml: 0, color: 'text.primary' }}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ pr: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
              <img src="/landbox.png" alt="Itinerary Box Logo" style={{ height: '32px' }} />
            </Box>
          </Toolbar>
        </AppBar>
      )}

      {/* Mobile Toolbar Spacer */}
      {isMobile && <Box sx={{ height: '48px' }} />}

      {/* Mobile Drawer */}
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            backgroundColor: theme.palette.background.paper
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            backgroundColor: theme.palette.background.paper
          },
        }}
        open
      >
        {drawer}
      </Drawer>

      {/* Logout Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={cancelLogout}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: '10px',
            width: '100%',
            p: 2
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WarningIcon sx={{ color: 'warning.main', mr: 2, fontSize: 28 }} />
          <Typography variant="h6">로그아웃</Typography>
        </Box>
        <DialogContent sx={{ pb: 0 }}>
          <Typography>로그아웃 하시겠습니까?</Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 3 }}>
          <Button
            onClick={cancelLogout}
            variant="outlined"
            sx={{
              borderRadius: '5px',
              minWidth: '100px',
              color: 'text.primary',
              borderColor: 'divider'
            }}
          >
            취소
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            variant="contained"
            sx={{
              borderRadius: '5px',
              minWidth: '100px',
              bgcolor: 'error.main',
              '&:hover': {
                bgcolor: 'error.dark'
              }
            }}
          >
            로그아웃
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SideMenu;
